import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import TutorSidebar from '../TutorSidebar/TutorSidebar';
import { jwtDecode } from 'jwt-decode';
import Beatloader from '../../../Common/BeatLoader';
import { v4 as uuidv4 } from "uuid";
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { getChatroomDetails, getMessageList } from '../../../Redux/action/MasterAction';
import axios from 'axios';

const host = process.env.REACT_APP_API_SERVER
const TutorChat = () => {
    const { b64id } = useParams(); // Get room ID from the URL
    const roomId = atob(b64id);
    const authToken = localStorage.getItem('tutor-token');
    const decoded = jwtDecode(authToken);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const dispatch = useDispatch();
    let config = {
        headers: {
            "x-auth-token": authToken, // Custom header with the token
        },
    };
    useEffect(() => {

        dispatch(getMessageList(authToken, roomId))
        dispatch(getChatroomDetails(authToken, roomId))
    }, []);


    const {
        loadingMessageListApi,
        MessageListApiData,
        MessageListApiError,

        loadingChatroomDetailApi,
        ChatroomDetailApiData,
        ChatroomDetailApiError

    } = useSelector(state => state?.MasterReducer);

    const [showNewMsgButton, setShowNewMsgButton] = useState(false);

    // 🏷️ Setup
    const chatContainerRef = useRef(null);
    const wasAtBottomRef = useRef(true);
    const lastMessageIdRef = useRef(null);
    const hasUnseenMessagesRef = useRef(false);

    // Poll messages every 3 seconds
    useEffect(() => {
        const intervalId = setInterval(() => {
            const container = chatContainerRef.current;
            if (container) {
                const distanceFromBottom =
                    container.scrollHeight - container.scrollTop - container.clientHeight;
                wasAtBottomRef.current = distanceFromBottom < 50;
            }
            dispatch(getMessageList(authToken, roomId));
        }, 3000);

        return () => clearInterval(intervalId);
    }, [dispatch, authToken, roomId]);

    // Watch for new messages
    useEffect(() => {
        const container = chatContainerRef.current;
        if (!container) return;

        const messages = MessageListApiData || [];
        const lastMessage = messages[messages.length - 1];
        const lastMessageId = lastMessage?.id || lastMessage?._id;

        const isNewMessage = lastMessageIdRef.current !== lastMessageId;
        const isFromCurrentUser = lastMessage?.sender_id === decoded?.user?.id;
        if (wasAtBottomRef.current) {
            container.scrollTo({
                top: container.scrollHeight,
                behavior: "smooth",
            });
            hasUnseenMessagesRef.current = false;
            setShowNewMsgButton(false);
        } else if (isNewMessage && !isFromCurrentUser) {
            hasUnseenMessagesRef.current = true;
            setShowNewMsgButton(true);
          }

        lastMessageIdRef.current = lastMessageId;
    }, [MessageListApiData]);

    // Listen for scroll
    useEffect(() => {
        const container = chatContainerRef.current;
        if (!container) return;

        const handleScroll = () => {
            const distanceFromBottom =
                container.scrollHeight - container.scrollTop - container.clientHeight;
            const nearBottom = distanceFromBottom < 50;

            wasAtBottomRef.current = nearBottom;

            if (nearBottom) {
                hasUnseenMessagesRef.current = false;
                setShowNewMsgButton(false);
            } else if (hasUnseenMessagesRef.current) {
                setShowNewMsgButton(true);
            } else {
                setShowNewMsgButton(false);
            }
        };

        container.addEventListener("scroll", handleScroll);
        return () => container.removeEventListener("scroll", handleScroll);
    }, []);


    const sendMessage = async () => {
        if (!newMessage.trim()) {
            toast.error("Message cannot be empty!");
            return;
        }

        try {
            const messageData = {
                chatroomId: roomId,
                sender_id: decoded?.user?.id,
                message: newMessage,
                msg_type: "text",
            };



            // Send text message to the API
            const response = await axios.post(`${host}/api/web/send-message`, messageData, config);

            if (response.data.statusCode == 200) {

                setNewMessage(""); // Clear the input after sending
                dispatch(getMessageList(authToken, roomId))
            } else {

                toast.error(response.data.message || "Failed to send message!");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            toast.error("Error sending message. Please try again!");
        }
    };

    // Function to handle file uploads (image or PDF)
    const handleFileUpload = async (file) => {
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
        if (!allowedTypes.includes(file.type)) {
            toast.error("Only images and PDF files are allowed!");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("chatroomId", roomId);
        formData.append("sender_id", decoded?.user?.id);
        formData.append("msg_type", file.type.startsWith("image/") ? "image" : "file");

        try {
            // Send file to the API
            const response = await axios.post(`${host}/api/web/send-message`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-auth-token": authToken,
                },
            });

            if (response.data.statusCode == 200) {

                dispatch(getMessageList(authToken, roomId))
            } else {
                toast.error(response.data.message || "Failed to upload file!");
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error("Error uploading file. Please try again!");
        }
    };

    // Handle file input change
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            handleFileUpload(file);
        }
    };

    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         dispatch(getMessageList(authToken, roomId));
    //     }, 3000); // Calls API every 3 seconds

    //     // Cleanup interval on component unmount
    //     return () => clearInterval(intervalId);
    // }, [dispatch, authToken, roomId]);


    return (
        <div style={{ position: "relative", height: "100%" }}>
            <section className="after-header">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item active ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Chat
                        </li>
                    </ol>
                </nav>
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            {loadingChatroomDetailApi ?
                                <Beatloader />
                                :
                                <main className="pt-0">
                                    <div className="chat-sec">

                                        <div className="card bg-light" style={{ border: "none" }}>

                                            <div className="card-body" style={{ height: '40rem' }}>
                                                <div className="row" style={{ height: '10%' }}>
                                                    <div className="col-lg-12">
                                                        <div className="col-lg-4 col-md-4">
                                                            <div className="row bg-light">
                                                                <div className="col-lg-2 col-md-3 col-2 pe-0">
                                                                    <img
                                                                        onError={(e) => {
                                                                            e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                        }}
                                                                        src={`${host}${ChatroomDetailApiData?.otherParticipant?.profile_img}`}
                                                                        className="img-fluid rounded-circle"
                                                                        style={{ height: 45, width: 48 }}
                                                                    />
                                                                </div>
                                                                <div className="col-lg-8 col-md-8 col-8">
                                                                    <p className="mb-0" style={{ fontSize: 16 }}>
                                                                        {ChatroomDetailApiData?.otherParticipant?.name} {/* Dynamic user name */}
                                                                    </p>
                                                                    <p className="mb-0" style={{ fontSize: 13 }}>
                                                                        {ChatroomDetailApiData?.otherParticipant?.online_status ? 'Online' : 'Offline'}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                {MessageListApiData?.length > 0 ? (
                                                    <>
                                                        <div ref={chatContainerRef} className="row my-3" style={{ height: '70%', overflowY: 'auto' }}>
                                                            {/* Group messages by date */}
                                                            {Object.entries(
                                                                MessageListApiData?.reduce((acc, msg) => {
                                                                    const timeInSeconds = new Date(msg.createdAt).getTime() / 1000;  // Convert createdAt to seconds
                                                                    if (timeInSeconds) {
                                                                        const date = new Date(timeInSeconds * 1000).toLocaleDateString("en-US", {
                                                                            month: "short",
                                                                            day: "2-digit",
                                                                            year: "numeric",
                                                                        }); // Format as "Jan 16, 2025"
                                                                        if (!acc[date]) acc[date] = [];
                                                                        acc[date]?.push(msg);
                                                                    }
                                                                    return acc;
                                                                }, {})
                                                            )?.map(([date, dateMessages]) => (
                                                                <div key={date}>
                                                                    {/* Display Date Header */}
                                                                    <div className="col-lg-12 d-flex justify-content-center">
                                                                        <div className="date">
                                                                            <p className="mb-0 px-2 py-2">{date}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="message-list">
                                                                        {/* Display Messages for the Date */}
                                                                        {dateMessages.map((msg) => (
                                                                            <div
                                                                                className={`col-lg-12 mt-3 d-flex justify-content-${msg.sender_id == decoded?.user?.id ? "end" : "start"}`}
                                                                                key={msg.id}
                                                                            >
                                                                                {msg.msg_type === 'text' && (
                                                                                    <div className={`px-2 message ${msg.sender_id == decoded?.user?.id ? "my-msg" : "other-msg"}`}>
                                                                                        <p className="mb-0 px-3 pt-2 pb-0 text-light">{msg.message}</p>
                                                                                        <span className="msg-date ms-0 d-flex justify-content-end">
                                                                                            {/* {msg.createdAt
                                                                                            ? `${new Date(msg.createdAt).getUTCHours().toString().padStart(2, "0")}:${new Date(msg.createdAt).getUTCMinutes().toString().padStart(2, "0")}`
                                                                                            : ""} */}

                                                                                            {msg.createdAt
                                                                                                ? new Date(msg.createdAt).toLocaleTimeString([], {
                                                                                                    hour: "2-digit",
                                                                                                    minute: "2-digit",
                                                                                                })
                                                                                                : ""}
                                                                                        </span>
                                                                                    </div>
                                                                                )}

                                                                                {msg.msg_type === 'image' && (
                                                                                    <div className={`message ${msg.sender_id === ChatroomDetailApiData?.otherParticipant?.name ? "my-img" : "other-img"}`}>
                                                                                        <a href={`${host}${msg.message}`} target="blank">
                                                                                            <img width={200} src={`${host}${msg.message}`} alt="Attachment" />
                                                                                        </a>
                                                                                        <span className="msg-date">
                                                                                            {msg.createdAt
                                                                                                ? new Date(msg.createdAt).toLocaleTimeString([], {
                                                                                                    hour: "2-digit",
                                                                                                    minute: "2-digit",
                                                                                                })
                                                                                                : ""}
                                                                                        </span>
                                                                                    </div>
                                                                                )}

                                                                                {msg.msg_type === 'file' && (
                                                                                    <div className={`message ${msg.sender_id === ChatroomDetailApiData?.otherParticipant?.name ? "my-pdf" : "other-pdf"}`}>
                                                                                        <a href={`${host}${msg.message}`} target="blank">
                                                                                            <img width={100} src="/assets/img/user/pdf.png" alt="PDF" />
                                                                                        </a>
                                                                                        <span className="msg-date">
                                                                                            {msg.createdAt
                                                                                                ? new Date(msg.createdAt).toLocaleTimeString([], {
                                                                                                    hour: "2-digit",
                                                                                                    minute: "2-digit",
                                                                                                })
                                                                                                : ""}
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {showNewMsgButton && (
                                                            <button
                                                                className="new-msg-button"
                                                                onClick={() => {
                                                                    chatContainerRef.current.scrollTo({
                                                                        top: chatContainerRef.current.scrollHeight,
                                                                        behavior: "smooth",
                                                                    });
                                                                    setShowNewMsgButton(false);
                                                                }}
                                                                style={{
                                                                    position: "absolute",
                                                                    bottom: "100px",
                                                                    right: "40%",
                                                                    zIndex: 10,
                                                                    background: "#007bff",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "20px",
                                                                    padding: "10px 20px",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                New Messages
                                                            </button>
                                                        )}

                                                    </>
                                                ) : (
                                                    <div className="row">
                                                        <div className="col-md-12 d-flex justify-content-center align-items-center flex-column" style={{ opacity: '0.5' }}>
                                                            <img width={200} src="/assets/img/user/talk-show.png" alt="No messages" />
                                                            <h2>Start Conversation</h2>
                                                        </div>
                                                    </div>
                                                )}



                                                <div className="chat-container" style={{ height: '16%' }}>
                                                    <input
                                                        type="text"
                                                        className="message-input"
                                                        value={newMessage}
                                                        onChange={(e) => setNewMessage(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" && !e.shiftKey) {
                                                                e.preventDefault();
                                                                sendMessage();
                                                            }
                                                        }}
                                                        placeholder="Enter Message"
                                                    />

                                                    <label className="file-upload-button" title="Upload file">
                                                        <input
                                                            type="file"
                                                            accept="image/*, application/pdf" // Restrict file selection to images and PDFs
                                                            style={{ display: "none" }}
                                                            onChange={handleFileChange}
                                                        />
                                                        <i className="fas fa-paperclip text-dark " style={{ cursor: 'pointer' }} />
                                                    </label>
                                                    <button className="send-button" onClick={sendMessage}>
                                                        <i className="bi bi-send-fill" />
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                            }
                            {/* <div ref={bottomRef}></div> */}
                        </div>
                    </div>
                </div>
            </section >
        </div >
    );
};
export default TutorChat;
